const CompanyWareHouse = () => import("./views/CompanyWareHouse.vue");
import DashboardLayout from "../../../views/Layout/DashboardLayout.vue";

const moduleRoute = {
  path: "/",
  component: DashboardLayout,
  children: [
    {
      path: "/company_ware_house",
      component: CompanyWareHouse,
      name: "Company Warehouse",
      meta: {
        groupName: "Master",
      },
    },
  ],
};

export default (router) => {
  router.addRoutes([moduleRoute]);
};
